module.exports = __webpack_public_path__ + "static/img/logo.b347b7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpg
// module id = 4GjL
// module chunks = 6